<template>
  <v-row>
    <LabelCol v-if="isLabelVisible" :cols="labelCols" :attribute="attribute" />
    <v-col :cols="valueCols" class="pa-0">
      <v-text-field
        :readonly="!canEdit"
        :disabled="isCopied"
        :value="value"
        @input="setValue"
        outlined
        :label="attribute.measure_unit?unitLabel(attribute.measure_unit):null"
        @keydown="isNumber"
        @paste.prevent
        :rules="rules"
        :loading="loading"
        v-bind="inputProps"
      >
        <template #append>
          <v-col class="pa-0" v-if="canEdit">
            <v-row no-gutters class="creament-arrow">
              <v-icon size="12px" color="black" @click="increment">mdi-chevron-up</v-icon>
            </v-row>
            <v-row no-gutters class="creament-arrow">
              <v-icon size="12px" color="black" @click="decrement">mdi-chevron-down</v-icon>
            </v-row>
          </v-col>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import LabelCol from './LabelCol';

export default {
  components: {
    LabelCol
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  methods: {
    setValue(value) {
      this.$emit('input', Number(value));
    },
    unitLabel(unit) {
      return new DOMParser().parseFromString(unit.replace('<sup>2</sup>', '&sup2'), 'text/html').body.textContent;
    },
    increment() {
      if (!this.canEdit) {
        return;
      }
      const newValue = (this.value ? this.value : 0) + this.stepValue;
      const fixedNewValue = newValue.toFixed(this.fixedValue);

      this.setValue(fixedNewValue);
    },
    decrement() {
      if (!this.canEdit) {
        return;
      }
      const newValue = (this.value ? this.value : 0) - this.stepValue;
      const fixedNewValue = newValue.toFixed(this.fixedValue);

      this.setValue(fixedNewValue);
    }
  },
  computed: {
    fixedValue() {
      return this.isTypeInt ? 0 : this.isTypeDecimal ? 2 : 5;
    },
    stepValue() {
      return this.isTypeInt ? 1 : this.isTypeDecimal ? 0.01 : 0.00001;
    },
    isTypeInt() {
      return this.attribute.subtype === 'integer';
    },
    isTypeDecimal() {
      return this.attribute.subtype === 'decimal';
    },
    rules() {
      const rules = [];
      if (this.attribute.required) {
        rules.push(value => !!value || this.$i18n.t('default.requiredField'));
      }
      if (this.isTypeInt) {
        rules.push(this.intRule);
      } else if (this.isTypeDecimal) {
        rules.push(this.decimalRule);
      } else {
        rules.push(this.floatRule);
      }
      return rules;
    }
  },
  created() {
    this.floatRule = v => /([0-9]+([.][0-9]+)?)/.test(v) || this.$i18n.t('default.mustBeNumber');
    this.intRule = v => /[0-9]/.test(v) || this.$i18n.t('default.mustBeInt');
    this.decimalRule = v => /^\s*-?[0-9]\d*(\.\d{1,2})?\s*$/.test(v) || this.$i18n.t('default.mustBeDecimal');
  }
};
</script>
<style lang="scss" scoped>
.creament-arrow {
  border: 1px solid #bababa;
  border-radius: 5px;
  margin: 0 !important;
}
</style>
